import { render, staticRenderFns } from "./SettingTab.vue?vue&type=template&id=9a8d403a"
import script from "./SettingTab.vue?vue&type=script&lang=js"
export * from "./SettingTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a8d403a')) {
      api.createRecord('9a8d403a', component.options)
    } else {
      api.reload('9a8d403a', component.options)
    }
    module.hot.accept("./SettingTab.vue?vue&type=template&id=9a8d403a", function () {
      api.rerender('9a8d403a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/lottery/components/SettingTab.vue"
export default component.exports